import { SharedColors } from "@fluentui/react";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AuthContext from "../../Services/AuthContext";
import LineChart from "../../Components/LineChart";

function VenturePayment() {
    const [user] = useContext(AuthContext);
    const [dataset, setDataset] = useState([]);
    const [labels, setLabels] = useState([]);
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/venture/${params.id}/payment/cumulative`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    _createDataset(data.payment, data.schedule, data.estimate, data.reserved);
                })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [params.id]);

    const _createDataset = (payment, schedule, estimate, reserved) => {
        let labels = [...Object.keys(payment), ...Object.keys(schedule), ...Object.keys(estimate)];
        let dataset = [];

        labels = labels.filter(_onlyUnique).sort();

        dataset.push(_createData(labels, payment, 'Płatności', SharedColors.blue10));
        dataset.push(_createData(labels, schedule, 'Harmonogram', SharedColors.green10));
        dataset.push(_createData(labels, estimate, 'Wolne', SharedColors.orange10));
        dataset.push(_createData(labels, reserved, 'Rezerwacje', SharedColors.blueMagenta10));

        setLabels(labels);
        setDataset(dataset);
    }

    const _onlyUnique = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    const _createData = (labels, data, title, color) => {
        let values = [];
        let last = 0;

        labels.forEach((item) => {
           if (data[item] !== undefined) {
               values.push(data[item]);
               last = data[item];
           } else {
               values.push(last);
           }
        });

        return {
            label: title,
            backgroundColor: color,
            data: values
        }
    }

    return (<LineChart labels={labels} dataset={dataset} />);
}

export default VenturePayment;